import { all, call, delay, put, SagaReturnType, takeLatest } from 'redux-saga/effects';

import * as notificationActions from '@/components/notification/Actions';
import * as playButtonActions from '@/components/playButton/Actions';
import { playButtonActionTypes } from '@/components/playButton/Constants';
import { getAudioPath } from '@/services/Constants';
import { processRequest } from '@/services/Api';

import type { GetSongRequestAction, Song } from '@/components/playButton/types';

export default function* playButtonSagas(): Generator {
	yield all([yield takeLatest(playButtonActionTypes.GET_SONG_REQUEST, handleGetSong)]);
}

interface GetSongResponse {
	data: Song;
}

export function* handleGetSong(action: GetSongRequestAction) {
	try {
		const { id, word, lang } = action.payload;
		let response: SagaReturnType<typeof processRequest> = yield call(
			processRequest,
			getAudioPath(lang, word),
		);
		let data = response.data as Song;
		let hasUrl = data?.url;
		while (!hasUrl) {
			const response_: SagaReturnType<typeof processRequest> = yield call(
				processRequest,
				getAudioPath(lang, word),
				'GET',
				{},
				false,
				false,
				{},
			);
			yield delay(1000);
			const data_ = response_.data as Song;
			hasUrl = data_.url;
			data = data_;
		}
		yield put(playButtonActions.getSongSuccess(id, data));
	} catch (e) {
		const error = e as { response?: { data?: { error?: string } } };
		yield put(
			notificationActions.createNotification(error.response?.data?.error, null, true, 5000),
		);
		yield put(playButtonActions.removeSong());
	}
}
